(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn();

    } else {
        RivalIQ.module('metrics.new.enums', function (enums) {
            enums.MetricFormatTypes = exportFn();
        });
    }

    function exportFn() {
        return {
            // This is the abbreviated format used for user facing summary display. For numeric types,
            // it should be ~7 characters of less.
            abbreviated: 'abbreviated',

            // This is the format used for user facing displays where there is more room and
            // desire to show more significant digits (e.g., tooltips in glance widgets).
            expanded: 'expanded',

            // This is for places where accuracy and computer-readability is important.
            csv: 'csv'
        };
    }
})();
